import { css, keyframes } from '@emotion/core'
import { withAlpha } from 'utils'

// Border-pulse ripple. Useful when the caller provides its own bg color.
export const createPulseButtonCss = (color: string, delayMs = 0) => {
  const kf = keyframes`
    0% {
      box-shadow:
        inset 0px 0px 0px 2px ${withAlpha(color, 0.45)},
        0px 0px 0px 0px ${withAlpha(color, 0.25)};
    }
    100% {
      box-shadow:
        inset 0px 0px 0px 1px ${withAlpha(color, 0.1)},
        0px 0px 0px 12px ${withAlpha(color, 0)};
    }
  `

  return css`
    animation: ${kf} 2200ms ${delayMs}ms infinite ease-out;
  `
}

// Large soft blob-glow that breathes and morphs organically.
// Place on an absolutely-positioned Box centered over an icon; the blur bleeds
// well outside the parent bounds to create the "living light" effect.
export const createBlobGlowCss = (color: string) => {
  const kf = keyframes`
    0%, 100% {
      border-radius: 60% 40% 55% 45% / 55% 45% 60% 40%;
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    35% {
      border-radius: 45% 55% 38% 62% / 62% 38% 56% 44%;
      transform: translate(-50%, -50%) scale(1.14);
      opacity: 0.8;
    }
    70% {
      border-radius: 56% 44% 64% 36% / 38% 62% 42% 58%;
      transform: translate(-50%, -50%) scale(0.92);
      opacity: 0.95;
    }
  `

  return css`
    background: radial-gradient(circle, ${withAlpha(color, 0.32)} 0%, transparent 68%);
    filter: blur(10px);
    animation: ${kf} 5s ease-in-out infinite;
  `
}
